// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'

// Import 3rd Party
import 'axios/dist/axios.min';
import 'qs/dist/qs';
import 'aos';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import singleSurgeons from './routes/surgeons';

// Import Map functionality
import './practiceMap';
import './maps';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  // Surgeon single template
  singleSurgeons,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js